module.exports = __webpack_public_path__ + "img/office-2016-leave-taida.437a5bad.jpg";